import api from '../../api/auth'

const app = new Vue({
  i18n,
	el: '#authRegisterVerify',
	data () {
		return {
			mobile: '',
			verifyCode: '',
			isSubmitting: false,
			countdown: 60
		}
	},
	mounted () {
		this.mobile = $('#inputMobileNumber').val()
		this.startCountdown()

		setTimeout(() => {
			this.focus()
		}, 10)
	},
	methods: {
		focus () {
			$('#inputVerifyCode').focus()
		},
		onFocus () {
			$('.verify-wrapper').addClass('focus')
			$('.alert').remove()
		},
		onBlur () {
			$('.verify-wrapper').removeClass('focus')
		},
		onChange (value) {
			const valueSplit = value.split('')

			for(let i = 0; i < 4; i++) {
				const index = i + 1

				$(`#verifyCode_${index}`).removeClass('active')
				if(_.size(valueSplit) == i) {
					$(`#verifyCode_${index}`).addClass('active')
				}

				$(`#verifyCode_${index} .label`).html("")
				if(_.has(valueSplit, i)) {
					$(`#verifyCode_${index} .label`).html(valueSplit[i])
				}
			}
		},
		onSubmit (e) {
			this.$validator.validateAll().then((result) => {
				if(result) {
					this.isSubmitting = true
					e.preventDefault()

					const verifyCode = this.verifyCode

					if(verifyCode.length != 4) {
						this.verifyCode = ''
						this.focus()
						return
					}

					const mobile = this.mobile

					const data = {
						number: mobile,
						verify_code: this.verifyCode,
					}
					
					api.registerVerify(mobile, data, (response) => {
						this.isSubmitting = false
						this.alertSuccessMessage(response)
					}, (e) => {
						this.isSubmitting = false
						this.verifyCode = ''
						this.focus()
						this.alertErrorMessage(e, '#authRegisterVerify')
					})
				}
			})
		},
		onResend () {

			const mobile = this.mobile
			const data = {
				mobile: mobile
			}
			api.registerResendSms(data, (response) => {
				this.countdown = 60
				this.startCountdown()
				this.alertSuccessMessage(response, '#authRegisterVerify')
				$('#resendWaiting').show()
				$('#resendSms').hide()
			}, (e) => {
				this.alertErrorMessage(e, '#authRegisterVerify')
			})

		},
		startCountdown () {
			if(!this.countdown) {
				$('#resendWaiting').hide()
				$('#resendSms').show()
				return
			}

			setTimeout(() => {
				this.countdown--
				this.startCountdown()
			}, 1000)
		}
	},
	watch: {
		verifyCode: {
			handler: function (value) {
				this.onChange(value)
			},
			immediate: true
		},
		countdown: {
			handler: function (value) {
				const minute = Math.floor(value / 60)
				const second = value % 60

				$('.countdown').html(`${_.padStart(minute, 2, '0')}:${_.padStart(second, 2, '0')}`)
			},
			immediate: true
		}
	}
})